import { create } from 'zustand';
import { getUserProfile, createOrUpdateUserProfile } from '../services/firebase';

export const useAuthStore = create((set, get) => ({
  user: null,
  userProfile: null,
  loading: true,

  setUser: async (user) => {
    set({ user });

    if (user) {
      try {
        // First, ensure the user profile exists (create if new user)
        console.log('📝 Ensuring user profile exists for:', user.uid);
        await createOrUpdateUserProfile(user);
        console.log('✅ User profile created/updated');

        // Then fetch the profile
        console.log('📥 Fetching user profile...');
        const profile = await getUserProfile(user.uid);
        console.log('📄 User profile fetched:', profile ? 'exists' : 'null');
        set({ userProfile: profile });
      } catch (error) {
        console.error('❌ Error setting up user profile:', error);
        // Set profile to null on error rather than throwing
        set({ userProfile: null });
        throw error; // Re-throw so App.jsx can handle it
      }
    } else {
      set({ userProfile: null });
    }
  },

  setUserProfile: (profile) => set({ userProfile: profile }),

  setLoading: (loading) => set({ loading }),

  updateUserProfile: (updates) => {
    const { userProfile } = get();
    if (userProfile) {
      set({ userProfile: { ...userProfile, ...updates } });
    }
  },

  logout: () => {
    set({ user: null, userProfile: null });
  }
}));
